export default "__VITE_ASSET__Bg15YhGJ__"